"use client";
import type { EmbeddedForm } from "@/generated/sb";
import HubspotForm from "./HubspotForm";
import SalesforceForm from "./SalesforceForm";

export default function EmbeddedForm({
  blok,
  sectionName,
}: {
  blok: EmbeddedForm;
  sectionName?: string;
}) {
  return (
    <>
      {blok.source === "hubspot" && <HubspotForm sectionName={sectionName} />}
      {blok.source === "salesforce" && (
        <SalesforceForm
          type={blok.salesforceFormType}
          sectionName={sectionName}
        />
      )}
    </>
  );
}
